<mat-form-field
  id="data-picker-form"
  class="date-picker-form"
  appearance="fill"
>
  <mat-datepicker-toggle
    class="mat-date-range"
    matSuffix
    id="data-picker-toggle"
    [for]="picker"
  ></mat-datepicker-toggle>

  <mat-date-range-picker
    id="data-range-picker-toggle"
    [panelClass]="rangePickerPanelClass"
    appMaxRangeCalendar="{{ dateRange }}"
    touchUi
    #picker
  >
    <mat-date-range-picker-actions id="data-range-picker-action">
      <div
        id="date-range-picker-actions-wrapper"
        class="date-range-picker-actions-wrapper"
        [ngClass]="actionsFooterClasses"
      >
        <app-button
          id="data-range-picker-action-close"
          class="data-range-picker-action-btn"
          [text]="'daterange.close' | translate"
          [buttonType]="'textLink'"
          [isTextLinkBtn]="'true'"
          (buttonClick)="({})"
          mat-button
          matDateRangePickerCancel
        >
        </app-button>

        <app-button
          id="data-range-picker-action-set"
          class="data-range-picker-action-set"
          [text]="'daterange.set' | translate"
          mat-raised-button
          [buttonType]="'primary'"
          (buttonClick)="({})"
          matDateRangePickerApply
        >
        </app-button>
      </div>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
  <app-icon
    [name]="'daterange.cancle.icon' | translate"
    size="2em"
    id="daterange-icon"
    class="cancel-icon"
    (click)="resetDateRange()"
  ></app-icon>
  <mat-date-range-input
    id="data-range-picker-action-seprator"
    separator="to"
    [formGroup]="range"
    [rangePicker]="picker"
  >
    <input
      id="mat-start-date"
      readonly
      matStartDate
      (dateInput)="dateSelectedStart(range.value)"
      formControlName="start"
    />

    <input
      id="mat-end-date"
      readonly
      matEndDate
      (dateInput)="dateSelectedEnd(range.value)"
      formControlName="end"
    />
  </mat-date-range-input>
</mat-form-field>
